import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as ReactDOMClient from 'react-dom/client';

// import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(<App />);
// Removed strict because it was causing 2 renders in development and pissed me off for the strokePlain

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
